



















































































































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import NavbarItem from "../../components/navbar-item/NavbarItem.vue";
import { NavbarBus } from "../index";
import { Debounce } from "vue-debounce-decorator";
import { i18n } from "../i18n";

@Component({
    name: "Navbar",
    components: {
        "navbar-item": NavbarItem
    }
})
export default class Navbar extends Vue {
    @Prop({ default: i18n.dateFormat }) readonly format!: string;
    @Prop() value!: boolean;
    @Prop() highlightMenu!: boolean;
    @Prop({ type: Boolean }) hideMenu!: boolean;
    @Prop({ type: Boolean }) hasSecondaryNavbar!: boolean;
    @Prop({ type: Boolean }) hasCompactSidebarMenu!: boolean;

    private navBarItemOpen = 0;
    private showFilterList = false;

    private windowHTML: HTMLElement | null = null;
    private resizeWindowObserver: ResizeObserver | null = null;
    private resizeWindowTimerId: number | null = null;
    private windowWidth = 0;
    private smWidth = 640;
    private mdWidth = 768;
    private lgWidth = 1024;
    private xlWidth = 1280;
    private xxlWidth = 1536;
    private isSM = false;

    mounted() {
        this.windowHTML = this.$refs.navbar_container as HTMLElement;
        if (this.windowHTML) {
            this.windowWidth = this.windowHTML.clientWidth;
            this.resCheck();
            this.toggleDoubleToolbarClass();
        }

        NavbarBus.$on("open", (id: number) => {
            this.showFilterList = this.windowWidth !== 0 && this.isSM ? true : false;
            this.navBarItemOpen = id;
            NavbarBus.$emit("opened", id);
            const filterMobileList = document.getElementsByClassName("tf-filter-mobile-list") as any;
            if (filterMobileList && filterMobileList.length > 0) {
                filterMobileList[0].classList.add("tf-filter-mobile-list-hidden");
            }
        });
        NavbarBus.$on("close", (id: number) => {
            if (this.navBarItemOpen === id) {
                this.navBarItemOpen = 0;
                this.showFilterList = false;
                const filterMobileList = document.getElementsByClassName("tf-filter-mobile-list") as any;
                if (filterMobileList && filterMobileList.length > 0) {
                    filterMobileList[0].classList.remove("tf-filter-mobile-list-hidden");
                }
            }
        });

        this.addWindowWidthObserver();

        const frkNavFrame = document.querySelector(".frk-navigation-frame");
        if (frkNavFrame) {
            if (!this.hasCompactSidebarMenu) {
                if (frkNavFrame.classList.contains("frk-navigation-frame-has-compact-menu")) {
                    frkNavFrame.classList.remove("frk-navigation-frame-has-compact-menu");
                }
            } else {
                if (!frkNavFrame.classList.contains("frk-navigation-frame-has-compact-menu")) {
                    frkNavFrame.classList.add("frk-navigation-frame-has-compact-menu");
                }
            }
        }
    }

    destroyed() {
        this.resetWindowWidthObserver();
    }

    closeNavBarItem() {
        NavbarBus.$emit("opened", 0);
    }

    public toggleMenu() {
        this.$emit("input", !this.value);
        this.closeNavBarItem();
    }

    public closeAll() {
        this.closeMenu();
        this.closeNavBarItem();
    }

    private closeMenu() {
        this.$emit("input", false);
    }

    private resetWindowWidthObserver() {
        if (this.resizeWindowTimerId !== null) {
            clearInterval(this.resizeWindowTimerId);
            this.resizeWindowTimerId = null;
        } else if (this.resizeWindowObserver !== null) {
            this.resizeWindowObserver.disconnect();
            this.resizeWindowObserver = null;
        }
    }
    private addWindowWidthObserver() {
        if (window.ResizeObserver && this.windowHTML) {
            this.resizeWindowObserver = new ResizeObserver(
                (/* elements */) => (this.windowWidth = this.windowHTML!.clientWidth)
            );
            this.resizeWindowObserver.observe(this.windowHTML);
        } else {
            this.resizeWindowTimerId = window.setInterval(() => (this.windowWidth = this.windowHTML!.clientWidth), 500);
        }
    }

    @Debounce(200)
    @Watch("windowWidth")
    private onWindowWidthUpdate() {
        this.resCheck();
    }

    private resCheck() {
        if (this.windowWidth > this.xxlWidth) {
            this.isSM = false;
        } else if (this.windowWidth > this.xlWidth) {
            this.isSM = false;
        } else if (this.windowWidth > this.lgWidth) {
            this.isSM = false;
        } else if (this.windowWidth > this.mdWidth) {
            this.isSM = false;
        } else {
            this.isSM = true;
        }
    }

    @Debounce(200)
    @Watch("windowWidth")
    private toggleDoubleToolbarClass() {
        const frkNavigationFrame = document.getElementsByClassName("frk-navigation-frame") as any;
        if (frkNavigationFrame && frkNavigationFrame.length > 0) {
            if (this.hasSecondaryNavbar && ((this.windowWidth !== 0 && !this.isSM) || this.windowWidth === 0)) {
                frkNavigationFrame[0].classList.add("frk-navigation-frame-double-toolbar");
            } else {
                frkNavigationFrame[0].classList.remove("frk-navigation-frame-double-toolbar");
            }
        }
    }

    @Watch("showFilterList")
    private onShowList() {
        if (this.showFilterList) {
            requestAnimationFrame(() => {
                document.documentElement.addEventListener("click", this.onClickOutside, false);
            });
        } else {
            document.documentElement.removeEventListener("click", this.onClickOutside, false);
        }
    }

    private onClickOutside(event: Event | any) {
        const path = event.path || (event.composedPath ? event.composedPath() : undefined);
        // check if the MouseClick occurs inside the component
        const popoverEl = this.$refs.tf_filter_mobile_popover as HTMLElement;
        if (path && !path.includes(popoverEl) && !popoverEl!.contains(event.target as HTMLElement)) {
            this.showFilterList = false;
        }
    }
}
